module.exports = __webpack_public_path__ + "static/media/camera_unselected.4734035e.svg";